var map = {
	"./Asgard.png": [
		9348,
		348
	],
	"./Azteca.png": [
		2510,
		510
	],
	"./Gaul.png": [
		8473,
		473
	],
	"./Germania.png": [
		1150,
		150
	],
	"./Kemet.png": [
		9462,
		462
	],
	"./Nordhagen.png": [
		1352,
		352
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5945;
module.exports = webpackAsyncContext;